// extracted by mini-css-extract-plugin
module.exports = {"innerStyles__icon":"FieldInfoElement_innerStyles__icon__G4_tk","innerStyle__text":"FieldInfoElement_innerStyle__text__h7uMd"};